<div class="modal fade" tabindex="-1" [id]="'reactiveModal' + (id ? '-' + id : '')">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <i class="bi bi-exclamation-triangle fs-1 text-danger mb-2"></i>
        <h4 class="modal-title fw-bold">{{ (head ? head : 'COMMON.WILL_BE_REACTIVE') | translate }}</h4>
        <h5 *ngIf="head5" class="modal-title">{{ head5 }}</h5>
      </div>
      <div class="modal-body text-center">
        <p>{{ (message ? message : 'COMMON.SURE_TO_CONTINUE_REACTIVE') | translate:{ x: id } }}</p>
      </div>
      <div class="modal-footer">
        <button *ngIf="!hideConfirm" type="button" class="btn btn-dark" data-bs-dismiss="modal"
          (click)="confirm.emit()">{{ 'COMMON.CONFIRM'
          | translate }}</button>
        <button *ngIf="!hideConfirm" type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">{{
          'COMMON.CANCEL' | translate
          }}</button>
        <button *ngIf="hideConfirm" type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal"
          (click)="confirm.emit()">{{
          'COMMON.CANCEL' | translate
          }}</button>
      </div>
    </div>
  </div>
</div>